export default __webpack_public_path__ + "static/media/otege_blok_m.bce5ce09.png";